<template>
  <div class="input" :class="wrapperClasses">
    <BaseLabel
      v-if="label"
      :id="id"
      :number="number"
      :label="label"
      :label-description="labelDescription"
      :required="required"
      :help="help"
      :class="labelClasses"
    />
    <div :class="controlClasses">
      <BaseInput
        :id="id"
        v-model="text"
        :type="type"
        :count-chars="countChars"
        :max-chars="maxChars"
        :allow-all-caps="allowAllCaps"
        :all-caps-ratio="allCapsRatio"
        :error="error"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="$emit('input', text)"
      />
    </div>
    <div v-if="description || error" :class="descriptionClasses">
      <BaseControlDescription :id="id" :description="description" />
      <BaseControlError :id="id" :error="error" />
    </div>
  </div>
</template>

<script>
import BaseFormControl from "@/components/Base/Form/BaseFormControl";
import BaseInput from "@/components/Base/Controls/BaseInput";

export default {
  name: "InputControl",
  components: {
    BaseInput
  },
  extends: BaseFormControl,
  props: {
    countChars: {
      type: Boolean,
      default: false
    },
    maxChars: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: "text"
    },
    allowAllCaps: {
      type: Boolean,
      default: false
    },
    allCapsRatio: {
      type: Number,
      default: 0.5
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      text: this.value
    };
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.text = newValue;
      }
    }
  }
};
</script>
